<template>
  <div>
    <Hero
      >{{ $t('message.testDrive.beverageChoiceHeader') }}
      <img :src="require('@/assets/fa/hot-beverage.svg')" width="22" height="22" class="mb-1" alt="" />
      <template slot="description">{{ $t('message.testDrive.beverageChoiceDescription') }}</template>
    </Hero>
    <MobialisFormWithValidation v-slot="{ invalid, errors }" @onValidate="submit">
      <p class="error" v-if="invalid">
        {{ $t('message.testDrive.errorMessagePartOne') }}{{ $t('message.testDrive.errorMessagePartTwo')[4] }}
      </p>
      <BeverageRadio :options="availableBeverages" name="beverage-choice" v-model="setBeverage" />
      <mobialis-button class="cont-btn" type="submit" data-cy="continueBtn">{{
        $t('message.common.continue')
      }}</mobialis-button>
    </MobialisFormWithValidation>
  </div>
</template>
<script>
import Hero from '@/components/test-drive/Hero.vue';
import BeverageRadio from '@/components/test-drive/BeverageRadio.vue';

export default {
  name: 'BeverageChoice',
  components: {
    Hero,
    BeverageRadio,
  },
  data() {
    return {
      givenBeverages: [],
      beverages: this.$t('message.testDrive.beverages'),
      noBeverage: this.$t('message.testDrive.beverages[7]'),
    };
  },
  computed: {
    setBeverage: {
      get() {
        return this.$store.state.testDrive.chosenBeverage;
      },
      set(value) {
        this.$store.commit('testDrive/SET_CHOSEN_BEVERAGE', value);
      },
    },
    availableBeverages() {
      const holder = this.beverages.filter(item => this.givenBeverages.indexOf(item.value) !== -1);
      holder.push(this.noBeverage);
      return holder;
    },
  },
  methods: {
    submit(isValid) {
      if (isValid) {
        this.$router.push({
          name: `drive-personal-information-${this.baseRoute}`,
        });
      }
    },
  },
  created() {
    this.givenBeverages = this.$store.state.testDrive.settings.beverageOptions;
  },
};
</script>

<style lang="scss" scoped>
.cont-btn {
  margin-top: 40px;
  @media (min-width: $breakpoint-mobile) {
    margin-top: 116px;
  }
}
</style>
